
/**
 * @Name: 个人预订 service
 */

import request from '../request'
import apis from '../apis'
export default {

    /**
     * 查询省市区接口
     */
    findGeographyInfoPagedList(param) {
        return request.get(apis.GET_COUNTRY_LIST, { params: param });
    },

    /**
     * 查询个人信息接口
     */
    findPersonalUser(param) {
        return request.get(apis.FIND_PERSONAL_USER, { params: param });
    }
}
